import type { SavedSearch } from '../repositories/savedSearchRepository';

interface ForYouFeedPickerProps {
  searches: SavedSearch[];
  /** Ids currently being written; their checkbox is inert until the write lands. */
  pendingIds: ReadonlySet<string>;
  onToggle: (search: SavedSearch, included: boolean) => void;
}

/**
 * The collapsed control at the top of For You: every feed the reader has, with
 * the ones merged into the page checked.
 *
 * Membership is per-feed state on the server, so a toggle is a write and the
 * feed list is the source of truth for what is checked -- this component holds
 * no selection state of its own.
 */
export function ForYouFeedPicker({ searches, pendingIds, onToggle }: ForYouFeedPickerProps) {
  const included = searches.filter((search) => search.in_for_you).length;

  return (
    <details className="for-you-picker">
      <summary className="for-you-picker-summary">
        Feeds in this view
        <span className="for-you-picker-count">
          {included} of {searches.length}
        </span>
      </summary>
      <ul className="for-you-picker-list">
        {searches.map((search) => (
          <li key={search.id} className="for-you-picker-row">
            <label className="for-you-picker-label">
              <input
                type="checkbox"
                checked={search.in_for_you}
                disabled={pendingIds.has(search.id)}
                onChange={(event) => onToggle(search, event.target.checked)}
              />
              <span className="for-you-picker-name">{search.name}</span>
            </label>
            <span className="for-you-picker-description">{search.description}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
